export function upperCase(s) {
    return typeof s === 'string' ? s.toUpperCase() : s;
}

export function lowerCase(s) {
    return typeof s === 'string' ? s.toLowerCase() : s;
}

export function capitalize(s) {
    return typeof s === 'string' && s.length > 0 ? s[0].toUpperCase() + s.substr(1).toLowerCase() : s;
}

export function truncate(s, length, suffix) {
    if (s.length < length) {
        return s;
    }

    if (suffix) {
        return s.slice(0, length) + suffix;
    }

    return s.slice(0, length);
}

export function titleCase(s) {
    return s.replace(/\w+/g, capitalize);
}

export function camelCase(s) {
    const pascalCase = s.replace(/\w+/g, capitalize).replace(/\W/g, '').replaceAll(' ', '');
    return pascalCase.charAt(0).toLowerCase() + pascalCase.substring(1);
}

/**
 * Source:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
 *  */
export function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function intervalToString(interval) {
    switch (interval) {
        case 'week':
            return 'Weekly';
        case 'month':
            return 'Monthly';
    }
}
